
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/services/ot-awareness-training",
      function () {
        return require("private-next-pages/[locale]/services/ot-awareness-training.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/services/ot-awareness-training"])
      });
    }
  